import { useRef } from 'react';

export const useOnce = (callback) => {
  const mounted = useRef(false);

  if (!mounted.current) {
    callback();
    mounted.current = true;
  }
};
